import React, { useEffect, useRef, useState } from "react";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import { useDispatch, useSelector} from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { markAsRead, getUserNotifications, changeShops } from "services/auth/actions";
import { useOnClickOutside } from "components/hooks";
import { linkToSubdomain } from "../../subdomainLinkString";
import { Bell } from "../../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";
import useMobile from "../../../hooks/useMobile";
import useTheme from "../../../hooks/useTheme";
import { Feedback, Settings, Tickets, Products, Questions, Wallet, Reports,  } from "../../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons";

import "../style.scss";
import "./notification.scss";

TimeAgo.addLocale(en);
const ReactTimeAgo = new TimeAgo('en-US');


const ArrowIcon = () => {
	return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5 12H19" stroke="#121417" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M5 12L11 18" stroke="#121417" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M5 12L11 6" stroke="#121417" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
};

const Notification = () => {

	let { notifications, isAuth } = useSelector(({ auth }) => auth)
	let { id } = useSelector(({ auth }) => (auth.shop || {}))
	let isDark = useTheme();
	let dispatch = useDispatch();
	let history = useHistory();
	let isMobile = useMobile();
	let menuRef = useRef();

	let [isOpen, setOpen] = useState(false);
	let [isDashboard, setIsDashboard] = useState(false);

	let closeMenu = () => setOpen(false)
	let toggleMenu = () => setOpen(!isOpen)


	useOnClickOutside(menuRef, closeMenu);

	useEffect(() => {
		dispatch(getUserNotifications());
		setIsDashboard(window.location.origin.includes('dashboard'));
	}, []);

	let hasSome = notifications && notifications.length > 0;

	if(!isAuth) {
		return null
	}


	return <div className="notification-menu" ref={menuRef}  onClick={toggleMenu}>

		<div className="notification-menu-icon">
			<Bell />
			{hasSome ? <div className="notification-menu-icon-count" /> : null}
		</div>

		<div className={`notification-menu-dropdown customFadeIn ${isOpen ? 'open' : ''}`} style={notifications.length ? {} : {border: "none"}}>

			<div className="notification-menu-dropdown-header">
				<div className="notification-menu-dropdown-header-icon" onClick={toggleMenu}><ArrowIcon /></div>
				<div className="notification-menu-dropdown-header-title">
					<span>Notifications</span>
					{hasSome ? <div className="notification-menu-dropdown-header-count">
						{notifications.length}
					</div> : null}
				</div>

				<div className="notification-menu-dropdown-header-more">
					{hasSome ? isMobile ? null : <div className="notification-menu-dropdown-header-read" onClick={() => (notifications && notifications.length > 0) ? dispatch(markAsRead()) : null}>Mark all as read</div> : null}
					<Link to="/settings/notifications" className={`${isMobile && hasSome ? 'd-none' : 'd-flex'}`}><Settings /></Link>
				</div>
			</div>

			{hasSome ? <div className="notification-menu-dropdown-header-more-mobile">
				{hasSome ? <div className="notification-menu-dropdown-header-read" onClick={() => (notifications && notifications.length > 0) ? dispatch(markAsRead()) : null}>Mark all as read</div> : null}
				<Link to="/settings/notifications"><Settings /></Link>
			</div> : null}

			<div className="notification-menu-dropdown-body">
				{notifications.length ? "" : <div className="notification-menu-dropdown-nothing">No notifications left to read.</div>}
				{notifications.map((notify, key) => {

						let link = ''
						if(notify.type === 'QUERY_REPLIED' || notify.type === 'QUERY_CREATED') {
							link = `/tickets/${notify.uniqid}`
						}
						if(notify.type === 'FEEDBACK_RECEIVED') {
							link = `/feedback/reply/${notify.uniqid}`
						}
						if(notify.type === 'PRODUCT_STOCK_WARNING') {
							link = `/products/edit/${notify.uniqid}`
						}
						if(notify.type === 'INVOICE_TIME_WINDOW' || notify.type === 'INVOICE_AML' || notify.type === 'PAYPAL_DISPUTE_CREATED' || notify.type === 'INVOICE_CREATED' || notify.type === 'PRODUCT_SOLD') {
							link = `/invoices/${notify.uniqid}`
						}
						if(notify.type === 'CUSTOMER_QUESTION') {
							link = `/questions/${notify.uniqid}`
						}
						if(notify.type === 'ANALYTICS_REPORT') {
							link = `/analytics/reports`
						}

						let to = notify.shop_id === id || !notify.shop_id ? linkToSubdomain("dashboard", link, history) : "";

						let onclick = (e) => {
							e.preventDefault();
							dispatch(changeShops(notify.shop_id, linkToSubdomain('dashboard', link)))
						}

						if(isDashboard) {
							return <Link to={to} onClick={(e) => {
								if(notify.shop_id && (notify.shop_id !== id)) {
									onclick(e);
								}
							}} key={key}>
								<div className="notification-menu-dropdown-icon">
									{notify.type === 'QUERY_REPLIED' || notify.type === 'QUERY_CREATED' ? <Tickets dark={isDark} /> : null}
									{notify.type === 'FEEDBACK_RECEIVED' ? <Feedback dark={isDark} /> : null}
									{notify.type === 'PRODUCT_STOCK_WARNING' ? <Products dark={isDark} /> : null}
									{notify.type === 'CUSTOMER_QUESTION' ? <Questions dark={isDark} /> : null}
									{notify.type === 'INVOICE_AML' || notify.type === 'INVOICE_TIME_WINDOW' || notify.type === 'PAYPAL_DISPUTE_CREATED' || notify.type === 'INVOICE_CREATED' || notify.type === 'PRODUCT_SOLD' ? <Wallet dark={isDark} /> : null}
									{notify.type === 'ANALYTICS_REPORT' ? <Reports dark={isDark} /> : null}
								</div>
								<div>
									<span>{notify.message}</span>
									<i>{ReactTimeAgo.format(notify.created_at * 1000)}</i>
								</div>
							</Link>
						} else {
							return <a href={to} onClick={notify.shop_id !== id ? onclick : () => {}} key={key}>
								<div className="notification-menu-dropdown-icon">
									{notify.type === 'QUERY_REPLIED' || notify.type === 'QUERY_CREATED' ? <Tickets dark={isDark} /> : null}
									{notify.type === 'FEEDBACK_RECEIVED' ? <Feedback dark={isDark} /> : null}
									{notify.type === 'PRODUCT_STOCK_WARNING' ? <Products dark={isDark} /> : null}
									{notify.type === 'CUSTOMER_QUESTION' ? <Questions dark={isDark} /> : null}
									{notify.type === 'ANALYTICS_REPORT' ? <Reports dark={isDark} /> : null}
									{notify.type === 'INVOICE_TIME_WINDOW' || notify.type === 'INVOICE_AML' || notify.type === 'PAYPAL_DISPUTE_CREATED' || notify.type === 'INVOICE_CREATED' || notify.type === 'PRODUCT_SOLD' ? <Wallet dark={isDark} /> : null}
								</div>
								<div>
									<b>{notify.title}</b>
									<span>{notify.message}</span>
									<i>{ReactTimeAgo.format(notify.created_at * 1000)}</i>
								</div>
							</a>
						}
					})}
			</div>
		</div>

	</div>

}


export default Notification
